export const typingIndicatorText = (names: string[]): string | null => {
	switch (names.length) {
		case 0:
			return null;
		case 1:
			return `${names[0]} is typing`;
		case 2:
			return `${names.join(" and ")} are typing`;
		case 3:
		case 4:
			return `${names.slice(0, -1).join(", ")}, and ${names.at(-1)} are typing`;
		default:
			return "Several people are typing";
	}
};
